import { useMemo } from 'react';
import { useFeatureFlagsStore } from '../stores/featureFlagsStore';
import {
  DEFAULT_PARTICIPANT_LABEL_SINGULAR,
  DEFAULT_PARTICIPANT_LABEL_PLURAL,
} from '../types/featureFlags';

/**
 * User-configurable UI labels for the participant role (default “Student(s)”).
 * Does not change API field names, Entra role `student`, or entity_type `Student`.
 */
export function useParticipantLabels() {
  const singularRaw = useFeatureFlagsStore((s) => s.participantLabelSingular);
  const pluralRaw = useFeatureFlagsStore((s) => s.participantLabelPlural);
  const setParticipantLabelSingular = useFeatureFlagsStore((s) => s.setParticipantLabelSingular);
  const setParticipantLabelPlural = useFeatureFlagsStore((s) => s.setParticipantLabelPlural);

  return useMemo(() => {
    const singular =
      (singularRaw && singularRaw.trim()) || DEFAULT_PARTICIPANT_LABEL_SINGULAR;
    const plural = (pluralRaw && pluralRaw.trim()) || DEFAULT_PARTICIPANT_LABEL_PLURAL;
    return {
      singular,
      plural,
      singularLower: singular.toLowerCase(),
      pluralLower: plural.toLowerCase(),
      setParticipantLabelSingular,
      setParticipantLabelPlural,
    };
  }, [
    singularRaw,
    pluralRaw,
    setParticipantLabelSingular,
    setParticipantLabelPlural,
  ]);
}
